import React from 'react'
import { connect } from 'react-redux'
import isNil from 'lodash/isNil'
import { userUpdateRequest } from '../../../../../action/user-actions'
import { collapseLeftToolbar } from '../../../../../action/left-toolbar-state-actions'
import EditPassword from './edit-password'

class Edit extends React.Component {
  constructor(props) {
    super(props)
    const { user, states } = this.props,
      search = states.find(state => state.id === user.stateId),
      state = search ? search.name : ''


    this.state = {
      firstName: !isNil(user.firstName) ? user.firstName : '',
      lastName: !isNil(user.lastName) ? user.lastName : '',
      email: !isNil(user.email) ? user.email : '',
      phone: !isNil(user.phone) ? user.phone : '',
      city: !isNil(user.city) ? user.city : '',
      state,
      stateId: user.stateId,
      editPassword: false
    }
  }

  setStateId(e) {
    const { states } = this.props,
      id = isNaN(parseInt(e.target.value)) ? '' : parseInt(e.target.value),
      entry = states.find(state => state.id == id)

    this.setState({ stateId: entry ? entry.id : '', state: entry ? entry.name : '' })
  }

  updateUser() {
    const { user, cancelEdit, userUpdateRequest } = this.props,
      updated = Object.assign(user, this.state)

    delete updated.password
    delete updated.passwordSalt
    delete updated.userSubscription
    delete updated.userDevice
    updated.fullName = `${updated.firstName} ${updated.lastName}`
    console.log(userUpdateRequest(updated)
      .then(() => {
        cancelEdit()
      })
    )
  }

  onChange(e) {
    const { target } = e
    this.setState({ [target.id]: target.value })
  }

  render() {
    const { cancelEdit, states, collapseLeftToolbar } = this.props,
      { firstName, lastName, email, phone, city, stateId, editPassword } = this.state
    return (
      <div>
        {
          editPassword ? <EditPassword fromLeftBar={true} cancelEdit={() => {
            this.setState({ editPassword: false })
          }} /> : (
            <div>
              {/* <h2 style={{ padding: '10px' }}>Edit Profile</h2> */}
              <div className='left-expanded-header-container'>
                <span className='left-expanded-header'>Edit Profile</span>
                <div className='default-close left-dialog-close' onClick={collapseLeftToolbar}></div>
              </div>
              <div style={{ display: 'flex' }}>
                <div className='right-toolbar-profile-input-container'
                  style={{ width: '43%' }}>
                  <label htmlFor='firstName'
                    style={{
                      fontSize: '12px'
                    }}>First Name</label>
                  <input type='text'
                    name='firstName'
                    id='firstName'
                    className='left-toolbar-profile-input'
                    placeholder='First Name'
                    onChange={this.onChange.bind(this)}
                    value={firstName} />
                </div>
                <div className='right-toolbar-profile-input-container'
                  style={{ width: '43%' }}>
                  <label htmlFor='lastName'
                    style={{
                      fontSize: '12px'
                    }}>Last Name</label>
                  <input type='text'
                    name='lastName'
                    id='lastName'
                    className='left-toolbar-profile-input'
                    placeholder='Last Name'
                    onChange={this.onChange.bind(this)}
                    value={lastName}></input>
                </div>
              </div>
              <div style={{ display: 'flex' }}>
                <div className='right-toolbar-profile-input-container'
                  style={{ width: '92%' }}>
                  <label htmlFor='email'
                    style={{
                      fontSize: '12px'
                    }}>Email</label>
                  <input type='email'
                    className='left-toolbar-profile-input'
                    name='email'
                    id='email'
                    placeholder='Email'
                    onChange={this.onChange.bind(this)}
                    value={email}></input>
                </div>
              </div>
              <div style={{ display: 'flex' }}>
                <div className='right-toolbar-profile-input-container'
                  style={{ width: '92%' }}>
                  <label htmlFor='phone'
                    style={{
                      fontSize: '12px'
                    }}>Phone Number</label>
                  <input type='tel'
                    className='left-toolbar-profile-input'
                    name='phone'
                    id='phone'
                    placeholder='Phone Number'
                    onChange={this.onChange.bind(this)}
                    value={phone}></input>
                </div>
              </div>
              <div style={{ display: 'flex' }}>
                <div className='right-toolbar-profile-input-container'
                  style={{ width: '43%' }}>
                  <label htmlFor='city'
                    style={{
                      fontSize: '12px'
                    }}>City</label>
                  <input type='text'
                    name='city'
                    id='city'
                    className='left-toolbar-profile-input'
                    placeholder='City'
                    onChange={this.onChange.bind(this)}
                    value={city}
                  ></input>
                </div>
                <div className='right-toolbar-profile-input-container'
                  style={{ width: '43%' }}>
                  <label htmlFor='state'
                    style={{
                      fontSize: '12px',
                    }}>State</label>
                  <select
                    style={{
                      background: '#333333 0% 0% no-repeat padding-box',
                      opacity: 1,
                      marginTop: '5px',
                      height: '40px',
                      border: 'none',
                      borderRadius: '5px',
                      padding: '0 10px',
                      color: '#959595',
                    }}
                    value={stateId}
                    onChange={this.setStateId.bind(this)}>
                    {
                      [<option key='empty-state' value=''></option>].concat(
                        states.map(state => {
                          return (
                            <option key={state.abbreviation} value={state.id}>{state.name}</option>
                          )
                        }))
                    }
                  </select>
                </div>
              </div>
              <div style={{ display: 'flex' }}>
                <button style={{
                  width: '43%',
                  backgroundColor: 'gray'
                }}
                  onClick={cancelEdit}
                >Discard</button>
                <button style={{
                  width: '43%'
                }}
                  onClick={this.updateUser.bind(this)}>Save Changes</button>
              </div>
              <div>
                <a> <p style={{ textDecoration: 'underline', textAlign: 'center' }} onClick={e => {
                  e.preventDefault()
                  this.setState({ editPassword: true })
                }}>Update Password</p></a>
              </div>
            </div >
          )
        }
      </div>
    )
  }
}

const mapStateToProps = state => ({
  user: state.user,
  states: state.states
})

const mapDispatchToProps = dispatch => ({
  userUpdateRequest: user => (dispatch(userUpdateRequest(user))),
  collapseLeftToolbar: () => dispatch(collapseLeftToolbar())
})

export default connect(mapStateToProps, mapDispatchToProps)(Edit)